/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ClearChargingProfileTask } from "./ClearChargingProfileTask";
import {
    ClearChargingProfileTaskFromJSON,
    ClearChargingProfileTaskFromJSONTyped,
    ClearChargingProfileTaskToJSON,
} from "./ClearChargingProfileTask";
import type { GetDisplayedPriceTask } from "./GetDisplayedPriceTask";
import {
    GetDisplayedPriceTaskFromJSON,
    GetDisplayedPriceTaskFromJSONTyped,
    GetDisplayedPriceTaskToJSON,
} from "./GetDisplayedPriceTask";
import type { SetDefaultChargingProfileTask } from "./SetDefaultChargingProfileTask";
import {
    SetDefaultChargingProfileTaskFromJSON,
    SetDefaultChargingProfileTaskFromJSONTyped,
    SetDefaultChargingProfileTaskToJSON,
} from "./SetDefaultChargingProfileTask";
import type { SetDisplayedPriceTask } from "./SetDisplayedPriceTask";
import {
    SetDisplayedPriceTaskFromJSON,
    SetDisplayedPriceTaskFromJSONTyped,
    SetDisplayedPriceTaskToJSON,
} from "./SetDisplayedPriceTask";
import type { StartOcppLogUploadTask } from "./StartOcppLogUploadTask";
import {
    StartOcppLogUploadTaskFromJSON,
    StartOcppLogUploadTaskFromJSONTyped,
    StartOcppLogUploadTaskToJSON,
} from "./StartOcppLogUploadTask";
import type { ChangeExtendedConfigurationTask } from "./ChangeExtendedConfigurationTask";
import {
    ChangeExtendedConfigurationTaskFromJSON,
    ChangeExtendedConfigurationTaskFromJSONTyped,
    ChangeExtendedConfigurationTaskToJSON,
} from "./ChangeExtendedConfigurationTask";
import type { StartChargeTask } from "./StartChargeTask";
import {
    StartChargeTaskFromJSON,
    StartChargeTaskFromJSONTyped,
    StartChargeTaskToJSON,
} from "./StartChargeTask";
import type { UpdateFirmwareTask } from "./UpdateFirmwareTask";
import {
    UpdateFirmwareTaskFromJSON,
    UpdateFirmwareTaskFromJSONTyped,
    UpdateFirmwareTaskToJSON,
} from "./UpdateFirmwareTask";
import type { UpdatePayMateFirmwareTask } from "./UpdatePayMateFirmwareTask";
import {
    UpdatePayMateFirmwareTaskFromJSON,
    UpdatePayMateFirmwareTaskFromJSONTyped,
    UpdatePayMateFirmwareTaskToJSON,
} from "./UpdatePayMateFirmwareTask";
import type { UpdateSupervisionTask } from "./UpdateSupervisionTask";
import {
    UpdateSupervisionTaskFromJSON,
    UpdateSupervisionTaskFromJSONTyped,
    UpdateSupervisionTaskToJSON,
} from "./UpdateSupervisionTask";
import type { ActivateTask } from "./ActivateTask";
import {
    ActivateTaskFromJSON,
    ActivateTaskFromJSONTyped,
    ActivateTaskToJSON,
} from "./ActivateTask";
import type { LimitChargeTransactionTask } from "./LimitChargeTransactionTask";
import {
    LimitChargeTransactionTaskFromJSON,
    LimitChargeTransactionTaskFromJSONTyped,
    LimitChargeTransactionTaskToJSON,
} from "./LimitChargeTransactionTask";
import type { StopChargeTask } from "./StopChargeTask";
import {
    StopChargeTaskFromJSON,
    StopChargeTaskFromJSONTyped,
    StopChargeTaskToJSON,
} from "./StopChargeTask";
import type { SendMessageTask } from "./SendMessageTask";
import {
    SendMessageTaskFromJSON,
    SendMessageTaskFromJSONTyped,
    SendMessageTaskToJSON,
} from "./SendMessageTask";
import type { ChangeConfigurationTask } from "./ChangeConfigurationTask";
import {
    ChangeConfigurationTaskFromJSON,
    ChangeConfigurationTaskFromJSONTyped,
    ChangeConfigurationTaskToJSON,
} from "./ChangeConfigurationTask";
import type { DisableEnableChargingTask } from "./DisableEnableChargingTask";
import {
    DisableEnableChargingTaskFromJSON,
    DisableEnableChargingTaskFromJSONTyped,
    DisableEnableChargingTaskToJSON,
} from "./DisableEnableChargingTask";
import type { TriggerMessageTask } from "./TriggerMessageTask";
import {
    TriggerMessageTaskFromJSON,
    TriggerMessageTaskFromJSONTyped,
    TriggerMessageTaskToJSON,
} from "./TriggerMessageTask";
import type { PauseResumeChargeTransactionTask } from "./PauseResumeChargeTransactionTask";
import {
    PauseResumeChargeTransactionTaskFromJSON,
    PauseResumeChargeTransactionTaskFromJSONTyped,
    PauseResumeChargeTransactionTaskToJSON,
} from "./PauseResumeChargeTransactionTask";
import type { UnlockConnectorTask } from "./UnlockConnectorTask";
import {
    UnlockConnectorTaskFromJSON,
    UnlockConnectorTaskFromJSONTyped,
    UnlockConnectorTaskToJSON,
} from "./UnlockConnectorTask";
import type { SolarOverrideTask } from "./SolarOverrideTask";
import {
    SolarOverrideTaskFromJSON,
    SolarOverrideTaskFromJSONTyped,
    SolarOverrideTaskToJSON,
} from "./SolarOverrideTask";
import type { DeviceAlertTask } from "./DeviceAlertTask";
import {
    DeviceAlertTaskFromJSON,
    DeviceAlertTaskFromJSONTyped,
    DeviceAlertTaskToJSON,
} from "./DeviceAlertTask";
import type { SetCentralSystemPassThroughTask } from "./SetCentralSystemPassThroughTask";
import {
    SetCentralSystemPassThroughTaskFromJSON,
    SetCentralSystemPassThroughTaskFromJSONTyped,
    SetCentralSystemPassThroughTaskToJSON,
} from "./SetCentralSystemPassThroughTask";

/**
 * Populate the relevant '{TaskType}Task' field only, or null if this is a parameterless task type
 * @export
 * @interface TaskInfoRequestParametersObject
 */
export interface TaskInfoRequestParametersObject {
    /**
     *
     * @type {UpdateFirmwareTask}
     * @memberof TaskInfoRequestParametersObject
     */
    updateFirmwareTask?: UpdateFirmwareTask;
    /**
     *
     * @type {UpdatePayMateFirmwareTask}
     * @memberof TaskInfoRequestParametersObject
     */
    updatePayMateFirmwareTask?: UpdatePayMateFirmwareTask;
    /**
     *
     * @type {StartChargeTask}
     * @memberof TaskInfoRequestParametersObject
     */
    startChargeTask?: StartChargeTask;
    /**
     *
     * @type {StopChargeTask}
     * @memberof TaskInfoRequestParametersObject
     */
    stopChargeTask?: StopChargeTask;
    /**
     *
     * @type {UnlockConnectorTask}
     * @memberof TaskInfoRequestParametersObject
     */
    unlockConnectorTask?: UnlockConnectorTask;
    /**
     *
     * @type {ClearChargingProfileTask}
     * @memberof TaskInfoRequestParametersObject
     */
    clearChargingProfileTask?: ClearChargingProfileTask;
    /**
     *
     * @type {ChangeConfigurationTask}
     * @memberof TaskInfoRequestParametersObject
     */
    changeConfigurationTask?: ChangeConfigurationTask;
    /**
     *
     * @type {ChangeExtendedConfigurationTask}
     * @memberof TaskInfoRequestParametersObject
     */
    changeExtendedConfigurationTask?: ChangeExtendedConfigurationTask;
    /**
     *
     * @type {SendMessageTask}
     * @memberof TaskInfoRequestParametersObject
     */
    sendMessageTask?: SendMessageTask;
    /**
     *
     * @type {DeviceAlertTask}
     * @memberof TaskInfoRequestParametersObject
     */
    deviceAlertTask?: DeviceAlertTask;
    /**
     *
     * @type {LimitChargeTransactionTask}
     * @memberof TaskInfoRequestParametersObject
     */
    limitChargeTransactionTask?: LimitChargeTransactionTask;
    /**
     *
     * @type {SetDefaultChargingProfileTask}
     * @memberof TaskInfoRequestParametersObject
     */
    setDefaultChargingProfileTask?: SetDefaultChargingProfileTask;
    /**
     *
     * @type {ActivateTask}
     * @memberof TaskInfoRequestParametersObject
     */
    activateTask?: ActivateTask;
    /**
     *
     * @type {SolarOverrideTask}
     * @memberof TaskInfoRequestParametersObject
     */
    solarOverrideTask?: SolarOverrideTask;
    /**
     *
     * @type {SetCentralSystemPassThroughTask}
     * @memberof TaskInfoRequestParametersObject
     */
    setCentralSystemPassThroughTask?: SetCentralSystemPassThroughTask;
    /**
     *
     * @type {PauseResumeChargeTransactionTask}
     * @memberof TaskInfoRequestParametersObject
     */
    pauseResumeChargeTransactionTask?: PauseResumeChargeTransactionTask;
    /**
     *
     * @type {object}
     * @memberof TaskInfoRequestParametersObject
     */
    setCoreConfigurationTask?: object;
    /**
     *
     * @type {DisableEnableChargingTask}
     * @memberof TaskInfoRequestParametersObject
     */
    disableEnableChargingTask?: DisableEnableChargingTask;
    /**
     *
     * @type {TriggerMessageTask}
     * @memberof TaskInfoRequestParametersObject
     */
    triggerMessageTask?: TriggerMessageTask;
    /**
     *
     * @type {UpdateSupervisionTask}
     * @memberof TaskInfoRequestParametersObject
     */
    updateSupervisionTask?: UpdateSupervisionTask;
    /**
     *
     * @type {SetDisplayedPriceTask}
     * @memberof TaskInfoRequestParametersObject
     */
    setDisplayedPriceTask?: SetDisplayedPriceTask;
    /**
     *
     * @type {GetDisplayedPriceTask}
     * @memberof TaskInfoRequestParametersObject
     */
    getDisplayedPriceTask?: GetDisplayedPriceTask;
    /**
     *
     * @type {StartOcppLogUploadTask}
     * @memberof TaskInfoRequestParametersObject
     */
    startOcppLogUploadTask?: StartOcppLogUploadTask;
}

/**
 * Check if a given object implements the TaskInfoRequestParametersObject interface.
 */
export function instanceOfTaskInfoRequestParametersObject(
    value: object,
): value is TaskInfoRequestParametersObject {
    return true;
}

export function TaskInfoRequestParametersObjectFromJSON(
    json: any,
): TaskInfoRequestParametersObject {
    return TaskInfoRequestParametersObjectFromJSONTyped(json, false);
}

export function TaskInfoRequestParametersObjectFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TaskInfoRequestParametersObject {
    if (json == null) {
        return json;
    }
    return {
        updateFirmwareTask:
            json["updateFirmwareTask"] == null
                ? undefined
                : UpdateFirmwareTaskFromJSON(json["updateFirmwareTask"]),
        updatePayMateFirmwareTask:
            json["updatePayMateFirmwareTask"] == null
                ? undefined
                : UpdatePayMateFirmwareTaskFromJSON(
                      json["updatePayMateFirmwareTask"],
                  ),
        startChargeTask:
            json["startChargeTask"] == null
                ? undefined
                : StartChargeTaskFromJSON(json["startChargeTask"]),
        stopChargeTask:
            json["stopChargeTask"] == null
                ? undefined
                : StopChargeTaskFromJSON(json["stopChargeTask"]),
        unlockConnectorTask:
            json["unlockConnectorTask"] == null
                ? undefined
                : UnlockConnectorTaskFromJSON(json["unlockConnectorTask"]),
        clearChargingProfileTask:
            json["clearChargingProfileTask"] == null
                ? undefined
                : ClearChargingProfileTaskFromJSON(
                      json["clearChargingProfileTask"],
                  ),
        changeConfigurationTask:
            json["changeConfigurationTask"] == null
                ? undefined
                : ChangeConfigurationTaskFromJSON(
                      json["changeConfigurationTask"],
                  ),
        changeExtendedConfigurationTask:
            json["changeExtendedConfigurationTask"] == null
                ? undefined
                : ChangeExtendedConfigurationTaskFromJSON(
                      json["changeExtendedConfigurationTask"],
                  ),
        sendMessageTask:
            json["sendMessageTask"] == null
                ? undefined
                : SendMessageTaskFromJSON(json["sendMessageTask"]),
        deviceAlertTask:
            json["deviceAlertTask"] == null
                ? undefined
                : DeviceAlertTaskFromJSON(json["deviceAlertTask"]),
        limitChargeTransactionTask:
            json["limitChargeTransactionTask"] == null
                ? undefined
                : LimitChargeTransactionTaskFromJSON(
                      json["limitChargeTransactionTask"],
                  ),
        setDefaultChargingProfileTask:
            json["setDefaultChargingProfileTask"] == null
                ? undefined
                : SetDefaultChargingProfileTaskFromJSON(
                      json["setDefaultChargingProfileTask"],
                  ),
        activateTask:
            json["activateTask"] == null
                ? undefined
                : ActivateTaskFromJSON(json["activateTask"]),
        solarOverrideTask:
            json["solarOverrideTask"] == null
                ? undefined
                : SolarOverrideTaskFromJSON(json["solarOverrideTask"]),
        setCentralSystemPassThroughTask:
            json["setCentralSystemPassThroughTask"] == null
                ? undefined
                : SetCentralSystemPassThroughTaskFromJSON(
                      json["setCentralSystemPassThroughTask"],
                  ),
        pauseResumeChargeTransactionTask:
            json["pauseResumeChargeTransactionTask"] == null
                ? undefined
                : PauseResumeChargeTransactionTaskFromJSON(
                      json["pauseResumeChargeTransactionTask"],
                  ),
        setCoreConfigurationTask:
            json["setCoreConfigurationTask"] == null
                ? undefined
                : json["setCoreConfigurationTask"],
        disableEnableChargingTask:
            json["disableEnableChargingTask"] == null
                ? undefined
                : DisableEnableChargingTaskFromJSON(
                      json["disableEnableChargingTask"],
                  ),
        triggerMessageTask:
            json["triggerMessageTask"] == null
                ? undefined
                : TriggerMessageTaskFromJSON(json["triggerMessageTask"]),
        updateSupervisionTask:
            json["updateSupervisionTask"] == null
                ? undefined
                : UpdateSupervisionTaskFromJSON(json["updateSupervisionTask"]),
        setDisplayedPriceTask:
            json["setDisplayedPriceTask"] == null
                ? undefined
                : SetDisplayedPriceTaskFromJSON(json["setDisplayedPriceTask"]),
        getDisplayedPriceTask:
            json["getDisplayedPriceTask"] == null
                ? undefined
                : GetDisplayedPriceTaskFromJSON(json["getDisplayedPriceTask"]),
        startOcppLogUploadTask:
            json["startOcppLogUploadTask"] == null
                ? undefined
                : StartOcppLogUploadTaskFromJSON(
                      json["startOcppLogUploadTask"],
                  ),
    };
}

export function TaskInfoRequestParametersObjectToJSON(
    value?: TaskInfoRequestParametersObject | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        updateFirmwareTask: UpdateFirmwareTaskToJSON(
            value["updateFirmwareTask"],
        ),
        updatePayMateFirmwareTask: UpdatePayMateFirmwareTaskToJSON(
            value["updatePayMateFirmwareTask"],
        ),
        startChargeTask: StartChargeTaskToJSON(value["startChargeTask"]),
        stopChargeTask: StopChargeTaskToJSON(value["stopChargeTask"]),
        unlockConnectorTask: UnlockConnectorTaskToJSON(
            value["unlockConnectorTask"],
        ),
        clearChargingProfileTask: ClearChargingProfileTaskToJSON(
            value["clearChargingProfileTask"],
        ),
        changeConfigurationTask: ChangeConfigurationTaskToJSON(
            value["changeConfigurationTask"],
        ),
        changeExtendedConfigurationTask: ChangeExtendedConfigurationTaskToJSON(
            value["changeExtendedConfigurationTask"],
        ),
        sendMessageTask: SendMessageTaskToJSON(value["sendMessageTask"]),
        deviceAlertTask: DeviceAlertTaskToJSON(value["deviceAlertTask"]),
        limitChargeTransactionTask: LimitChargeTransactionTaskToJSON(
            value["limitChargeTransactionTask"],
        ),
        setDefaultChargingProfileTask: SetDefaultChargingProfileTaskToJSON(
            value["setDefaultChargingProfileTask"],
        ),
        activateTask: ActivateTaskToJSON(value["activateTask"]),
        solarOverrideTask: SolarOverrideTaskToJSON(value["solarOverrideTask"]),
        setCentralSystemPassThroughTask: SetCentralSystemPassThroughTaskToJSON(
            value["setCentralSystemPassThroughTask"],
        ),
        pauseResumeChargeTransactionTask:
            PauseResumeChargeTransactionTaskToJSON(
                value["pauseResumeChargeTransactionTask"],
            ),
        setCoreConfigurationTask: value["setCoreConfigurationTask"],
        disableEnableChargingTask: DisableEnableChargingTaskToJSON(
            value["disableEnableChargingTask"],
        ),
        triggerMessageTask: TriggerMessageTaskToJSON(
            value["triggerMessageTask"],
        ),
        updateSupervisionTask: UpdateSupervisionTaskToJSON(
            value["updateSupervisionTask"],
        ),
        setDisplayedPriceTask: SetDisplayedPriceTaskToJSON(
            value["setDisplayedPriceTask"],
        ),
        getDisplayedPriceTask: GetDisplayedPriceTaskToJSON(
            value["getDisplayedPriceTask"],
        ),
        startOcppLogUploadTask: StartOcppLogUploadTaskToJSON(
            value["startOcppLogUploadTask"],
        ),
    };
}
